import { useRouteLoaderData } from "react-router-dom";
import { IZipRootLoaderData } from "../interfaces/api";

export function useZipRootLoaderData() {
  return useRouteLoaderData("zipRoot") as IZipRootLoaderData;
}
